import { AxiosError } from "axios";
import environment from "../../../../environments/environment";
import { axiosInterceptor } from "../authInterceptor";

const MASTER_TRANSACTION_MANUAL_ENTRIES_URL = environment.masterTransactionManualEntriesURL;
const FUND_TRANSACTION_HISTORY_MANUAL_ENTRIES_URL = environment.postFundTransactionHistoryManual;
const INVOICE_TRANSACTION_HISTORY_MANUAL_ENTRIES_URL = environment.postInvoiceTransactionHistoryManual;
const INVOICE_TRANSACTION_HISTORY_MANUAL_ENTRIES_FILTER_URL = environment.postInvoiceTransactionHistoryManualFilter;
const INVOICE_TRANSACTION_HISTORY_MANUAL_ENTRIES_DELETE_URL = environment.deleteInvoiceTransactionHistoryManual;
const INVOICE_CREDITLINE_MANUAL_TRANSACTION_URL = environment.postCreditlineManualTransaction; 


export async function saveMasterTransactionManualEntries(masterTransactionsManualVo: any) {
  try {
    const saveMasterTransactionManualEntriesResponse = await axiosInterceptor.post(`${MASTER_TRANSACTION_MANUAL_ENTRIES_URL}`, masterTransactionsManualVo);
    return saveMasterTransactionManualEntriesResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function saveFundTransactionManualEntries(fundTransactionsManualVo: any) {
  try {
    const saveFundTransactionManualEntriesResponse = await axiosInterceptor.post(`${FUND_TRANSACTION_HISTORY_MANUAL_ENTRIES_URL}`, fundTransactionsManualVo);
    return saveFundTransactionManualEntriesResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
export async function saveInvoiceTransactionManualEntries(invoiceTransactionsManualVo: any) {
  try {
    const saveInvoiceTransactionManualEntriesResponse = await axiosInterceptor.post(`${INVOICE_TRANSACTION_HISTORY_MANUAL_ENTRIES_URL}`, invoiceTransactionsManualVo);
    return saveInvoiceTransactionManualEntriesResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function filterInvoiceTransactionManualEntries(filterCriteria: any) {
  try {
    const filterInvoiceTransactionManualEntriesResponse = await axiosInterceptor.post(`${INVOICE_TRANSACTION_HISTORY_MANUAL_ENTRIES_FILTER_URL}`, filterCriteria);
    return filterInvoiceTransactionManualEntriesResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}

 export async function deleteInvoiceTransactionManualDetailsById(Id: number, clientId: number) {
    try {
      const response = await axiosInterceptor.delete(`${INVOICE_TRANSACTION_HISTORY_MANUAL_ENTRIES_DELETE_URL}${Id}?clientId=${clientId}`);
      return response;
    } catch (error: any) {
      return error;
    }
  }

  export async function saveCreditlineTransactionManualEntries(creditlineManualPaymentManualVo: any) {
  try {
    const saveCreditlineManualPaymentEntriesResponse = await axiosInterceptor.post(`${INVOICE_CREDITLINE_MANUAL_TRANSACTION_URL}`, creditlineManualPaymentManualVo);
    return saveCreditlineManualPaymentEntriesResponse;
  } catch (error: any) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new Error("Unexpected error occurred");
  }
}
// export async function saveCreditlineManualWithdrawalsEntries(creditlineManualWithdrawalsManualVo: any) {
//   try {
//     const saveCreditlineManualWithdrawalsEntriesResponse = await axiosInterceptor.post(`${INVOICE_CREDITLINE_MANUAL_WITHDRAWALS_URL}`, creditlineManualWithdrawalsManualVo);
//     return saveCreditlineManualWithdrawalsEntriesResponse;
//   } catch (error: any) {
//     if (error instanceof AxiosError) {
//       throw error;
//     }
//     throw new Error("Unexpected error occurred");
//   }
// }
// export async function saveCreditlinePayoffManualEntries(creditlinePayoffManualVo: any) {
//   try {
//     const saveCreditlineManualWithdrawalsEntriesResponse = await axiosInterceptor.post(`${INVOICE_CREDITLINE_PAYOFF_URL}`, creditlinePayoffManualVo);
//     return saveCreditlineManualWithdrawalsEntriesResponse;
//   } catch (error: any) {
//     if (error instanceof AxiosError) {
//       throw error;
//     }
//     throw new Error("Unexpected error occurred");
//   }
// }